<template>
  <div class="warehouseDetail">
    <el-tabs type="border-card">
      <el-tab-pane :label="$t('warehouse.warehouseInfo')">
        <el-form
          label-width="100px"
          ref="warehouseDialog"
          :label-position="'right'"
          :model="detailInfo"
        >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.createWarehouseCode')" prop="storageCode">
                <el-input v-model="detailInfo.storageCode" class="inputWidth" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.status')" prop="status">
                <el-input
                  v-model="detailInfo.currentStatusName"
                  class="inputWidth"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.gmtCreateBy')" prop="personName">
                <el-input v-model="detailInfo.personName" class="inputWidth" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.gmtCreate')" prop="storageCreateTime">
                <el-date-picker
                  style="width: 100%"
                  v-model="detailInfo.storageCreateTime"
                  type="datetime"
                  disabled
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.isDirectDeliver')" prop="isDirectDeliver">
                <el-select
                  class="inputWidth"
                  v-model="detailInfo.isDirectDeliver"
                  disabled
                  filterable
                >
                  <el-option :label="$t('addSupplierDelivery.option.direct')" value="1"></el-option>
                  <el-option
                    :label="$t('addSupplierDelivery.option.notDirect')"
                    value="0"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 仓库类型 -->
            <el-col :span="6">
              <el-form-item label="仓库类型" prop="storageType">
                <el-select
                  v-model="detailInfo.storageType"
                  class="inputWidth"
                  filterable
                  maxlength="32"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in storageTypeList"
                    :value="item.value"
                    :label="item.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 存放品种 -->
            <el-col :span="6">
              <el-form-item label="存放品种" prop="productDesc">
                <el-input v-model="detailInfo.productDesc" class="inputWidth" disabled></el-input>
              </el-form-item>
            </el-col>

            <!-- 国家-省 -->
            <el-col :span="6">
              <el-row :gutter="24">
                <el-col :span="16" style="padding-right: 0">
                  <el-form-item label="国家" prop="countryCode">
                    <el-input
                      v-model="detailInfo.countryName"
                      class="inputWidth"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item class="isShowLabel" prop="provinceCode">
                    <el-input
                      v-if="detailInfo.provinceName"
                      v-model="detailInfo.provinceName"
                      class="inputWidth"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <!-- 市-地区 -->
            <el-col :span="6">
              <el-row :gutter="24">
                <el-col :span="16">
                  <el-form-item label="市" style="padding-right: 0" prop="cityCode">
                    <el-input
                      v-if="detailInfo.cityName"
                      v-model="detailInfo.cityName"
                      class="inputWidth"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item class="isShowLabel" prop="areaCode">
                    <el-input v-model="detailInfo.areaName" class="inputWidth" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-form-item :label="$t('warehouse.table.createWarehouseName')" prop="storageName">
                <el-input
                  v-model="detailInfo.storageName"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.search.warehouseNamePlaceholder')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$t('warehouse.table.createWarehouseAddress')"
                prop="storageAddress"
              >
                <el-input
                  v-model="detailInfo.storageAddress"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.storageAddressPlaceholder')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$t('warehouse.table.createWarehouseCompanyCode')"
                prop="storageCompanyCode"
              >
                <el-input
                  v-model="detailInfo.storageCompanyCode"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.storageCompanyCodePlaceholder')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$t('warehouse.table.createWarehouseCompanyName')"
                prop="storageCompanyName"
              >
                <el-input
                  v-model="detailInfo.storageCompanyName"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.storageCompanyNamePlaceholder')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.contractPerson')" prop="contractPerson">
                <el-input
                  v-model="detailInfo.contactPerson"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.contractPersonPlaceholder')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$t('warehouse.table.contractTelephone')"
                prop="contractTelephone"
              >
                <el-input
                  v-model="detailInfo.contactTelephone"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.contractTelephonePlaceholder')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.email')" prop="contractTelephone">
                <el-input
                  v-model="detailInfo.email"
                  class="inputWidth"
                  clearable
                  disabled
                  :placeholder="$t('warehouse.email')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.faxNo')" prop="contractTelephone">
                <el-input
                  v-model="detailInfo.faxNo"
                  class="inputWidth"
                  clearable
                  disabled
                  :placeholder="$t('warehouse.faxNo')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="department-content">{{ this.$t('warehouse.belongCompany') }}</div>

        <sirui-table
          ref="siruiTable"
          :buttonList="[]"
          :loading="false"
          :data="tableData"
          :paging="false"
          :setting="false"
          :reserve="false"
        >
          <vxe-table-column type="seq" :title="$t('table.index')" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :width="item.width"
            :sortable="item.sortable"
            :field="item.prop"
            :title="item.label"
          ></vxe-table-column>
        </sirui-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('company.system')">
        <mapping-data
          ref="mappingData"
          :isEdit="false"
          :detailInfo="detailInfo"
          :callLogsData="detailInfo.callLogs || []"
        />
      </el-tab-pane>
      <el-tab-pane :label="$t('company.history')">
        <div class="detail">
          <historyData ref="historyData"></historyData>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021050815465707752']"
        v-if="
          detailInfo.currentStatus == 'ZT03' ||
          detailInfo.currentStatus == 'ZT05' ||
          detailInfo.currentStatus == 'ZT06'
        "
        type="primary"
        class="fixed-bottom-btn"
        :loading="updateLoad"
        @click="update"
        >{{ $t('warehouse.update') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815472142456']"
        type="primary"
        class="fixed-bottom-btn"
        :loading="updateLoad"
        @click="fotbidStorage"
        >{{ $t('warehouse.forbid') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815473031158']"
        type="primary"
        class="fixed-bottom-btn"
        :loading="updateLoad"
        v-if="userInfo.userInfo.adminFlag == 1"
        @click="liftStorage"
        >{{ $t('warehouse.lift') }}</el-button
      >
      <!--  <el-button
        @click="cancel(false)"
        class="fixed-bottom-btn"
        type="primary"
        :disabled="detailInfo.currentStatus!='ZT05'"
      >{{$t("warehouse.giveUp")}}</el-button> -->
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  // import { isEqual } from '@/common/js/util';
  import SiruiTable from '@/components/SiruiTable';
  import historyData from './historyData';
  import BASE_API from '@/api/dataBase';
  import mappingData from '../mappingData'; // 系统映射表

  export default {
    name: 'warehouseDetail',
    components: {
      SiruiTable,
      historyData,
      mappingData,
    },
    data() {
      return {
        detailInfo: {
          storageName: null,
          storageAddress: null,
          storageCompanyCode: null,
          storageCompanyName: null,
          personName: null,
          contractTelephone: null,
          faxNo: null,
          email: null,
          storageType: null,
          productNo: null,
          productDesc: null,
          provinceCode: null,
          countryCode: null,
          cityCode: null,
          areaCode: null,
          provinceName: null,
          countryName: null,
          cityName: null,
          areaName: null,
        },
        updateLoad: false,
        tableData: [],
        historyData: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      storageTypeList() {
        let list = this.$baseRequest.getDictListMapByType('storage_type');
        return list;
      },
      countryList() {
        let list = this.$baseRequest.getDictListMapByType('person_national');
        return list;
      },
      columnList() {
        return [
          {
            prop: 'createCompanyName',
            label: this.$t('company.detail.companyName'),
          },
        ];
      },
    },
    mounted() {
      this.initData(this.$route.query.storageCode);
    },
    methods: {
      changeCountry(value) {
        this.changeProvince(this.detailInfo.provinceCode);
        this.$axios.post(BASE_API.QUERY_PROVICE + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.detailInfo.provinceName = res.data.data.find(
              (item) => item.value == this.detailInfo.provinceCode
            ).label;
            this.$forceUpdate();
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },

      // 省份切换 => 获取城市
      changeProvince(value) {
        this.changeCity(this.detailInfo.cityCode);
        this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.detailInfo.cityName = res.data.data.find(
              (item) => item.value == this.detailInfo.cityCode
            ).label;
            this.$forceUpdate();
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 城市切换 =》 获取地区
      changeCity(value) {
        this.$axios.post(BASE_API.QUERY_AERA + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.detailInfo.areaName = res.data.data.find(
              (item) => item.value == this.detailInfo.areaCode
            ).label;
            this.$forceUpdate();
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      initData(storageCode) {
        if (this.$refs['warehouseDialog']) {
          this.$refs['warehouseDialog'].resetFields();
        }
        this.getStorageData(storageCode);
        this.getHistoryData('storage', storageCode);
      },
      //初始化详情数据
      getStorageData(storageCode) {
        this.$axios.get(API.GET_STORAGE_DETAIL_API + '/' + storageCode).then((res) => {
          if (0 == res.data.code) {
            this.detailInfo = res.data.data;
            this.tableData = res.data.data.storageCompanyList;
            if (this.detailInfo.countryCode) {
              this.detailInfo.countryName = this.countryList.find(
                (item) => item.value == this.detailInfo.countryCode
              )?.label;
              this.changeCountry(this.detailInfo.countryCode);
            }
            if (this.detailInfo.mdgSystemMap)
              this.$refs.mappingData.initData([this.detailInfo.mdgSystemMap] || []);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      getHistoryData(type, code) {
        this.$refs.historyData.getData(type, code);
      },
      //禁用仓库
      fotbidStorage() {
        if (this.detailInfo.currentStatus != 'ZT03') {
          this.$message({
            showClose: true,
            message: this.$t('company.fotbidNoReason'),
            type: 'error',
          });
          return;
        }
        //非管理员需要填写禁用原因
        if (this.userInfo.userInfo.adminFlag == '2') {
          var specialValidate = (value) => {
            if (value == null || value == '') {
              return this.$t('warehouse.forbidReasonNotEmpty');
            } else {
              return true;
            }
          };
          this.$prompt(
            "<div><img src='./static/img/tips.png'/><div class='confirmTitle'>" +
              this.$t('confirm.forbid') +
              '</div>' +
              "<div class='confirmContent'>" +
              this.$t('confirm.forbidContent') +
              '</div></div>',
            '',
            {
              customClass: 'prompt-box',
              dangerouslyUseHTMLString: true,
              cancelButtonText: this.$t('confirm.cancel'),
              confirmButtonText: this.$t('confirm.confirm'),
              inputPlaceholder: this.$t('warehouse.forbidReason'),
              center: true,
              inputValidator: specialValidate,
            }
          )
            .then(({ value }) => {
              const params = {
                currentStatus: 'ZT04',
                version: this.detailInfo.version,
                storageCode: this.detailInfo.storageCode,
                forbidReason: value,
                adminFlag: this.userInfo.userInfo.adminFlag,
              };
              this.loading.startLoading();
              this.$axios.post(API.UPDATE_STORAGE_STATUS_API, params).then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.cancel(false);
                  this.$message({
                    showClose: true,
                    message: res.data.msg || this.$t('message.success'),
                    type: 'success',
                  });
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          //管理员直接禁用
          this.$confirmAction(this.$t('confirm.forbid'), this.$t('confirm.forbidContent'))
            .then(() => {
              const params = {
                currentStatus: 'ZT04',
                version: this.detailInfo.version,
                storageCode: this.detailInfo.storageCode,
                adminFlag: this.userInfo.userInfo.adminFlag,
              };
              this.loading.startLoading();
              this.$axios.post(API.UPDATE_STORAGE_STATUS_API, params).then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.cancel(false);
                  this.$message({
                    showClose: true,
                    message: res.data.msg || this.$t('message.success'),
                    type: 'success',
                  });
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      //启用仓库
      liftStorage() {
        if (this.userInfo.userInfo.adminFlag == 2) {
          this.$message({
            showClose: true,
            message: this.$t('company.adminReason'),
            type: 'error',
          });
          return;
        }
        if (this.detailInfo.currentStatus != 'ZT04') {
          this.$message({
            showClose: true,
            message: this.$t('company.liftNoReason'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction(this.$t('confirm.lift'), this.$t('confirm.liftContent'))
          .then(() => {
            const params = {
              currentStatus: 'ZT03',
              version: this.detailInfo.version,
              storageCode: this.detailInfo.storageCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            };
            this.loading.startLoading();
            this.$axios.post(API.UPDATE_STORAGE_STATUS_API, params).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.cancel(false);
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //跳转至修改页面
      update() {
        let path = {
          fromPath: {
            path: '/masterData/warehouseDetail',
            name: 'warehouseDetail',
            meta: {
              keepAlive: true,
              title: '仓库详情',
            },
          },
          toPath: {
            path: '/masterData/editWarehouse',
            name: 'editWarehouse',
            meta: {
              keepAlive: true,
              title: '仓库修改',
            },
            query: {
              storageCode: this.$route.query.storageCode,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //取消至列表页面
      cancel(keepAlive) {
        let path = {
          fromPath: {
            path: '/masterData/warehouseDetail',
            name: 'warehouseDetail',
            meta: {
              keepAlive: true,
              title: '仓库详情',
            },
          },
          toPath: {
            path: '/masterData/warehouse',
            name: 'warehouse',
            meta: {
              keepAlive: keepAlive,
              title: '仓库维护',
            },
          },
        };
        if (this.detailInfo.currentStatus == 'ZT05') {
          this.$axios
            .post(API.GIVE_WAREHOSE_API, { storageCode: this.detailInfo.storageCode })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('warehouse.forGiveSuccess'),
                  type: 'success',
                });
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('warehouse.forGiveError'),
                  type: 'error',
                });
                return;
              }
            });
        }
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
<style>
  .warehouseDetail .isShowLabel .el-form-item__content {
    margin-left: 0 !important;
  }
</style>
<style lang="scss" scoped>
  .warehouseDetail {
    margin-bottom: 90px;
  }
  .department-content {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
</style>
